<template>
  <vue-scroll>
  <div class="company-credit-record-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="tableToolsPanel.indexOf('filter')>-1?'隐藏筛选条件':'展开筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="类别" prop="type">
                  <RadioGroup v-model="filterModel.type" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">失信记录</Radio>
                    <Radio :label="0">履约记录</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="企业名称" prop="companyName">
                  <Input v-model="filterModel.companyName" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="企业类型" prop="companyType">
                  <Select v-model="filterModel.companyType" filterable style="width:200px">
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.companyType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="项目" prop="projectName">
                  <Input v-model="filterModel.projectName" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="原因" prop="reason">
                  <Input v-model="filterModel.reason" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="发布日期" prop="publishDate">
                  <Date-picker type="daterange" :value="filterModel.publishDateRange" @on-change="changePublishDateRange"></Date-picker>
                  <!-- <Date-picker type="date" :value="filterModel.publishDate" @on-change="changePublishDate" style="width: 150px"></Date-picker> -->
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/company-credit-record/new" icon="md-add">新增企业信用记录</Button>
    </div>
    <div class="padding-top-10"></div>
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
  </vue-scroll>
</template>

<script>
export default {
  name: 'company-credit-record-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '类型',
          key: 'type',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.companyCreditRecordType[params.row.type.toString()])
          }
        },
        {
          title: '名称',
          key: 'companyName',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '项目',
          key: 'projectName',
          resizable: true,
          width: 200,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '保函编号',
          key: 'guaranteeOrderNumber',
          resizable: true,
          width: 180,
          render: (h, params) => {
            return h('router-link', {
              attrs: {
                title: '查看保函详情'
              },
              props: {
                to: {name: 'guarantee-detail', params: {orderNumber: params.row.guaranteeOrderNumber}}
              }
            }, [
              params.row.guaranteeOrderNumber,
              ' ',
              h('Icon', {
                props: {
                  type: 'md-open'
                }
              })
            ])
          }
        },
        {
          title: '原因',
          key: 'reason',
          resizable: true,
        },
        {
          title: '处理结果',
          key: 'conclusion',
          resizable: true,
        },
        {
          title: '发布日期',
          key: 'publishDate',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.getMoment(params.row.publishDate).format('YYYY-MM-DD'))
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'company-credit-record-detail', params: {companyCreditRecordId: params.row.tid}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'company-credit-record-edit', params: {companyCreditRecordId: params.row.tid}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let companyId = params.row.tid
                      this.deleteCompany(companyId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        companyName: null,
        companyId: null,
        projectId: null,
        projectName: null,
        type: null,
        guaranteeId: null,
        reason: null,
        fact: null,
        conclusion: null,
        publishDate: null,
        publishDateRange: null,
        publishDateFrom: null,
        publishDateTo: null
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    changePublishDate (dt) {
      this.filterModel.publishDate = this.getMoment(dt).format('YYYY-MM-DD')
    },
    changePublishDateRange (dates) {
      if (dates instanceof Array) {
        this.filterModel.publishDateFrom = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.publishDateTo = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    getMoment (dt) {
      return this.$moment(dt)
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.CompanyCreditRecord.listCompanyCreditRecord(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteCompany (companyId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.CompanyCreditRecord.deleteCompanyCreditRecord(companyId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.tid === companyId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.company-credit-record-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
